import {memo, useEffect} from 'react';
import {usePrevious} from '../../../../../../common/shared/hooks/usePrevious';
import {twMerge} from '../../../../../../common/twMerge';
import {Icon} from '../../../../../../design-system/atoms/Icon/Icon';
import {IconType} from '../../../../../../design-system/atoms/Icon/IconType.enum';
import {
  MAX_BASE_VIEWER_WIDTH_PX,
  MOBILE_PULL_COMPONENT_HEIGHT,
  PC_PULL_COMPONENT_HEIGHT,
} from '../constant/talkViewerConstant';
import {useViewerWidth} from '../hook/useViewerWidth.hook';
import {SceneKey} from '../type/KeyType.type';
import {ZIndex} from '../type/ZIndex.enum';
import {disableScroll} from '../util/disableScroll';
import {enableScroll} from '../util/enableScroll';

interface BottomPullProps {
  height: number;
  nextSceneId?: SceneKey;
  isMobile: boolean;
  isPreview: boolean;
  onViewerPulledUp: Function;
}

export const TalkViewerEventHandleBottomPull = memo(
  ({
    height,
    nextSceneId,
    isMobile,
    isPreview,
    onViewerPulledUp,
  }: BottomPullProps) => {
    const {viewerWidth} = useViewerWidth();
    const maxHeight =
      // 미리보기모드 && 다음씬정보 없으면 다음 대화 이동 노출하지 않음
      isPreview && !nextSceneId
        ? 0
        : (isMobile ? MOBILE_PULL_COMPONENT_HEIGHT : PC_PULL_COMPONENT_HEIGHT) *
          (viewerWidth / MAX_BASE_VIEWER_WIDTH_PX);
    const componentHeight = Math.min(maxHeight, height);
    const prevHeight = usePrevious(componentHeight);

    const isPulled = prevHeight === maxHeight && height === 0;

    if (isMobile) {
      if (height <= 0) {
        enableScroll();
      } else {
        disableScroll();
      }
    }
    useEffect(() => {
      return () => {
        enableScroll();
      };
    }, []);

    useEffect(() => {
      if (!isMobile) {
        return;
      }
      if (isPreview && !nextSceneId) {
        return;
      }
      if (isPulled) {
        onViewerPulledUp();
      }
    }, [nextSceneId, isPulled, isMobile, isPreview, onViewerPulledUp]);
    return (
      <div
        className={twMerge(
          'pointer-events-none absolute bottom-0 mb-50tvs flex w-full flex-col items-center justify-center overflow-hidden text-static-mono-white',
          !isMobile && 'relative mb-0 justify-start'
        )}
        style={{
          zIndex: ZIndex.ViewerMenu - 1,
          height: `${isMobile ? maxHeight : componentHeight}px`,
        }}
      >
        <Icon
          type={IconType.KatalknovelAfter}
          style={{
            width: componentHeight / 2,
            height: componentHeight / 2,
          }}
        />
      </div>
    );
  }
);
